import { RootState } from 'editor/src/store/index';

const getCurrentSpreadIndex = (state: RootState) => state.editor.currentSpreadIndex;

export default getCurrentSpreadIndex;
